/**
 * Created by Jerker Nord on 2024-05-13.
 */
import {BasicBitmapCountUp, BitmapTextStyleOptions} from "../../../components/BasicBitmapCountUp";
import {gsap} from "gsap";

export class SSDBitmapCountup extends BasicBitmapCountUp {

    constructor(style: BitmapTextStyleOptions, maxWidth?: number, anchor?: PIXI.Point) {
        super(style, maxWidth, anchor);
    }

    public getCountAnimation(from: number, to: number, duration: number, countUpMultipliers: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({onUpdate: () => this.updateText()});
        tl.add(() => this.stopAt(from));
        tl.add(() => {
            this._activeAnimation = tl
        });
        tl.add(() => this.updateTextLayout());
        tl.add(gsap.to(this, {
            duration: duration, currentCountValue: to, ease: "none"
        }));
        tl.add(() => this.setAmount(to));
        return tl;
    }

    protected updateTextLayout():void {
        this._amountText.position.set(-this._amountText.width * this._anchor.x, -this._amountText.height * this._anchor.y);
    }

    protected setAmount(value: number): void {
        this._amountText.text = "x" + value.toFixed(0).toString();
        this.updateTextLayout()
    }

    public forceSetText(newString: string): void {
        this._amountText.text = newString;
        this.updateTextLayout()
    }

}